import { render, staticRenderFns } from "./DashBoardIcon.vue?vue&type=template&id=2b052a97"
import script from "./DashBoardIcon.vue?vue&type=script&lang=js"
export * from "./DashBoardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports